/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ProductPoolRequestDTOLocationsEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the ProductPoolRequestDTO interface.
 */
export function instanceOfProductPoolRequestDTO(value) {
    return true;
}
export function ProductPoolRequestDTOFromJSON(json) {
    return ProductPoolRequestDTOFromJSONTyped(json, false);
}
export function ProductPoolRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'scanIds': json['scanIds'] == null ? undefined : json['scanIds'],
        'locations': json['locations'] == null ? undefined : new Set(json['locations']),
    };
}
export function ProductPoolRequestDTOToJSON(json) {
    return ProductPoolRequestDTOToJSONTyped(json, false);
}
export function ProductPoolRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'scanIds': value['scanIds'],
        'locations': value['locations'] == null ? undefined : Array.from(value['locations']),
    };
}
